// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users_header_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    margin-bottom: 16px;
}

.users_header_box h1 {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
}

.users_count_div {
    display: flex;
    align-items: center;
    background-color: var(--primary-light);
    color: var(--primary);
    padding: 6px 14px;
    border-radius: var(--radius-sm);
    font-weight: 600;
    font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/users/users.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,+BAA+B;IAC/B,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,qBAAqB;IACrB,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".users_header_box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 20px;\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    margin-bottom: 16px;\n}\n\n.users_header_box h1 {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.users_count_div {\n    display: flex;\n    align-items: center;\n    background-color: var(--primary-light);\n    color: var(--primary);\n    padding: 6px 14px;\n    border-radius: var(--radius-sm);\n    font-weight: 600;\n    font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
